import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { INICIA_ANO_LETIVO, SALVA_ANO_LETIVO, ATUALIZA_ANO_LETIVO, BUSCA_ANO_LETIVO_EDICAO, REMOVE_ANO_LETIVO, LISTA_ANO_LETIVO, LISTA_TIPOS_ETAPAS_ANO_LETIVO, LISTA_ESCOLAS_ANO_LETIVO, ON_HIDE_LOADER, ANOLETIVO_TIPOETAPA_SALVAR, ANOLETIVO_TIPOETAPA_ATUALIZAR } from "constants/ActionTypes";
import requisicaoApi from 'util/Api';
import { salvaAnoLetivoSucesso, removeAnoLetivoSucesso, inicioAnoLetivoSucesso, buscaAnoLetivoEdicaoSucesso, listaAnoLetivoSucesso, listaTiposEtapasAnoLetivoSucesso, listaEscolasAnoLetivoSucesso, showAuthMessage, showSuccessMessage, listaTiposEtapasAnoLetivo, salvarTipoEtapaSucesso, atualizarTipoEtapaSucesso } from "actions/AnoLetivo";
import moment from 'moment';

function normalizaAnoLetivoLista(payload) {
  const anos = Array.isArray(payload?.anosLetivos) ? payload.anosLetivos : (Array.isArray(payload) ? payload : []);
  const anosComAcoes = anos.map(x => {
    const statusRaw = x.status || x.Status || '';
    const status = String(statusRaw).toLowerCase();
    const podeIniciar = status === 'criado' || status === 'novo';
    const podeFinalizar = status === 'iniciado' || status === 'andamento';
    const podeReabrir = status === 'finalizado';
    const acoes = { iniciar: podeIniciar, finalizar: podeFinalizar, reabrir: podeReabrir };
    return { ...x, acoes };
  });
  return { anosLetivos: anosComAcoes };
}

function* fnIniciaAnoLetivo() {
  try {
    const res = yield call(requisicaoApi.get, '/anos-letivos/inicio');
    const data = res.data || {};
    yield put(inicioAnoLetivoSucesso(normalizaAnoLetivoLista(data)));
  } catch (e) {
    yield put(showAuthMessage('Falha ao iniciar Ano Letivo'));
    yield put({ type: ON_HIDE_LOADER });
  }
}

function* fnSalvaAnoLetivo(action) {
  try {
    const body = action.payload || {};
    const periodosUI = Array.isArray(body.periodosEtapas) ? body.periodosEtapas : [];
    const periodosReq = periodosUI.map(p => ({
      DataInicial: (() => {
        const v = p.dataInicio;
        if (!v) return null;
        if (typeof v === 'string') {
          const m1 = moment(v, 'DD/MM/YYYY', true);
          if (m1.isValid()) return m1.format('YYYY-MM-DD');
          const m2 = moment(v);
          return m2.isValid() ? m2.format('YYYY-MM-DD') : null;
        }
        const m3 = moment(v);
        return m3.isValid() ? m3.format('YYYY-MM-DD') : null;
      })(),
      DataFinal: (() => {
        const v = p.dataFim;
        if (!v) return null;
        if (typeof v === 'string') {
          const m1 = moment(v, 'DD/MM/YYYY', true);
          if (m1.isValid()) return m1.format('YYYY-MM-DD');
          const m2 = moment(v);
          return m2.isValid() ? m2.format('YYYY-MM-DD') : null;
        }
        const m3 = moment(v);
        return m3.isValid() ? m3.format('YYYY-MM-DD') : null;
      })(),
      DiasLetivos: (p.diasLetivos != null ? Number(p.diasLetivos) : null)
    }));
    const req = {
      IdEscola: body.escolaId,
      Ano: body.ano,
      Status: body.status,
      EtapaAnoLetivoId: body.tipoEtapaId,
      CopiarProfessores: !!body.copiarProfessores,
      CopiarServidores: !!body.copiarServidores,
      Periodos: periodosReq
    };
    const res = yield call(requisicaoApi.post, '/anos-letivos', req);
    const msg = res.data?.mensagem || 'Ano letivo salvo com sucesso';
    yield put(salvaAnoLetivoSucesso(msg));
    yield put({ type: LISTA_ANO_LETIVO, payload: {} });
  } catch (e) {
    const data = (e && e.response && e.response.data) || {};
    const inconsist = Array.isArray(data.inconsistencias) ? data.inconsistencias : [];
    const primeira = inconsist.length > 0 ? (inconsist[0]?.mensagem || '') : '';
    const msg = primeira || data.mensagem || 'Erro ao salvar Ano Letivo';
    yield put(showAuthMessage(msg));
    yield put({ type: ON_HIDE_LOADER });
  }
}

function* fnAtualizaAnoLetivo(action) {
  try {
    const body = action.payload || {};
    const id = body.id || 0;
    const periodosUI = Array.isArray(body.periodosEtapas) ? body.periodosEtapas : [];
    const periodosReq = periodosUI.map(p => ({
      DataInicial: (() => {
        const v = p.dataInicio;
        if (!v) return null;
        if (typeof v === 'string') {
          const m1 = moment(v, 'DD/MM/YYYY', true);
          if (m1.isValid()) return m1.format('YYYY-MM-DD');
          const m2 = moment(v);
          return m2.isValid() ? m2.format('YYYY-MM-DD') : null;
        }
        const m3 = moment(v);
        return m3.isValid() ? m3.format('YYYY-MM-DD') : null;
      })(),
      DataFinal: (() => {
        const v = p.dataFim;
        if (!v) return null;
        if (typeof v === 'string') {
          const m1 = moment(v, 'DD/MM/YYYY', true);
          if (m1.isValid()) return m1.format('YYYY-MM-DD');
          const m2 = moment(v);
          return m2.isValid() ? m2.format('YYYY-MM-DD') : null;
        }
        const m3 = moment(v);
        return m3.isValid() ? m3.format('YYYY-MM-DD') : null;
      })(),
      DiasLetivos: (p.diasLetivos != null ? Number(p.diasLetivos) : null)
    }));
    const req = {
      IdEscola: body.escolaId,
      Ano: body.ano,
      Status: body.status,
      EtapaAnoLetivoId: body.tipoEtapaId,
      CopiarProfessores: !!body.copiarProfessores,
      CopiarServidores: !!body.copiarServidores,
      Periodos: periodosReq
    };
    const res = yield call(requisicaoApi.put, `/anos-letivos/${id}`, req);
    const msg = res.data?.mensagem || 'Ano letivo atualizado com sucesso';
    yield put(salvaAnoLetivoSucesso(msg));
    // Após atualizar (inclui finalização), atualiza listagem para refletir status
    yield put({ type: LISTA_ANO_LETIVO, payload: {} });
  } catch (e) {
    const data = (e && e.response && e.response.data) || {};
    const inconsist = Array.isArray(data.inconsistencias) ? data.inconsistencias : [];
    const primeira = inconsist.length > 0 ? (inconsist[0]?.mensagem || '') : '';
    const msg = primeira || data.mensagem || 'Erro ao atualizar Ano Letivo';
    yield put(showAuthMessage(msg));
    yield put({ type: ON_HIDE_LOADER });
  }
}

function* fnBuscaAnoLetivoEdicao(action) {
  try {
    const id = action.payload || 0;
    const res = yield call(requisicaoApi.get, `/anos-letivos/${id}`);
    const data = res.data || {};
    yield put(buscaAnoLetivoEdicaoSucesso(data));
  } catch (e) {
    yield put(showAuthMessage('Erro ao carregar Ano Letivo'));
    yield put({ type: ON_HIDE_LOADER });
  }
}

function* fnRemoveAnoLetivo(action) {
  try {
    const id = action.payload || 0;
    const res = yield call(requisicaoApi.delete, `/anos-letivos/${id}`);
    const msg = res.data?.mensagem || 'Ano letivo removido com sucesso';
    yield put(removeAnoLetivoSucesso(msg));
  } catch (e) {
    yield put(showAuthMessage('Erro ao remover Ano Letivo'));
    yield put({ type: ON_HIDE_LOADER });
  }
}

function* fnListaAnoLetivo(action) {
  try {
    const filtros = action.payload || {};
    const params = {
      search: filtros.search,
      Ano: filtros.Ano,
      EscolaId: filtros.EscolaId,
      Status: filtros.Status
    };
    const res = yield call(requisicaoApi.get, '/anos-letivos', { params });
    const data = res.data || {};
    yield put(listaAnoLetivoSucesso(normalizaAnoLetivoLista(data)));
  } catch (e) {
    yield put(showAuthMessage('Falha ao listar Anos Letivos'));
    yield put({ type: ON_HIDE_LOADER });
  }
}

function* fnListaTiposEtapasAnoLetivo(action) {
  try {
    const res = yield call(requisicaoApi.get, `/etapas-ano-letivo`);
    const tipos = Array.isArray(res.data) ? res.data : (res.data?.etapas || res.data?.tipos || []);
    yield put(listaTiposEtapasAnoLetivoSucesso(tipos));
  } catch (e) {
    yield put(showAuthMessage('Falha ao listar tipos de etapas'));
    yield put({ type: ON_HIDE_LOADER });
  }
}

// Modal Tipo de Etapa: salvar
function* fnSalvarTipoEtapa({ payload }) {
  try {
    const dados = payload || {};
    const body = { descricao: dados.descricao, qtdEtapas: Number(dados.qtdEtapas || 0) };
    const res = yield call(requisicaoApi.post, `/tipos-etapas`, body);
    const msg = res?.data?.mensagem || 'Tipo de Etapa salvo com sucesso';
    yield put(salvarTipoEtapaSucesso(msg));
    const escolaId = dados.escolaId || null;
    if (escolaId) yield put(listaTiposEtapasAnoLetivo(escolaId));
    // Se o tipo salvo for o atualmente selecionado, nada impede UI já estar em sincronia via reducer.
    yield put(showSuccessMessage(msg));
  } catch (e) {
    yield put(showAuthMessage('Falha ao salvar Tipo de Etapa'));
    yield put({ type: ON_HIDE_LOADER });
  }
}

// Modal Tipo de Etapa: atualizar
function* fnAtualizarTipoEtapa({ payload }) {
  try {
    const id = payload?.id;
    const dados = payload?.dados || {};
    const body = { descricao: dados.descricao, qtdEtapas: Number(dados.qtdEtapas || 0) };
    const res = yield call(requisicaoApi.put, `/tipos-etapas/${id}`, body);
    const msg = res?.data?.mensagem || 'Tipo de Etapa atualizado com sucesso';
    yield put(atualizarTipoEtapaSucesso(msg));
    const escolaId = dados.escolaId || null;
    if (escolaId) yield put(listaTiposEtapasAnoLetivo(escolaId));
    // A sincronização do array periodosEtapas ocorre ao receber a lista atualizada no reducer.
    yield put(showSuccessMessage(msg));
  } catch (e) {
    yield put(showAuthMessage('Falha ao atualizar Tipo de Etapa'));
    yield put({ type: ON_HIDE_LOADER });
  }
}

function* fnListaEscolasAnoLetivo() {
  try {
    const res = yield call(requisicaoApi.get, `/escolas`);
    const escolas = Array.isArray(res.data) ? res.data : (res.data?.escolas || []);
    yield put(listaEscolasAnoLetivoSucesso(escolas));
  } catch (e) {
    yield put(showAuthMessage('Falha ao listar escolas'));
    yield put({ type: ON_HIDE_LOADER });
  }
}

export function* iniciaAcoesAnoLetivo() { yield takeEvery(INICIA_ANO_LETIVO, fnIniciaAnoLetivo); }
export function* salvaAnoLetivoW() { yield takeEvery(SALVA_ANO_LETIVO, fnSalvaAnoLetivo); }
export function* atualizaAnoLetivoW() { yield takeEvery(ATUALIZA_ANO_LETIVO, fnAtualizaAnoLetivo); }
export function* buscaAnoLetivoEdicaoW() { yield takeEvery(BUSCA_ANO_LETIVO_EDICAO, fnBuscaAnoLetivoEdicao); }
export function* removeAnoLetivoW() { yield takeEvery(REMOVE_ANO_LETIVO, fnRemoveAnoLetivo); }
export function* listaAnoLetivoW() { yield takeEvery(LISTA_ANO_LETIVO, fnListaAnoLetivo); }
export function* listaTiposEtapasAnoLetivoW() { yield takeEvery(LISTA_TIPOS_ETAPAS_ANO_LETIVO, fnListaTiposEtapasAnoLetivo); }
export function* listaEscolasAnoLetivoW() { yield takeEvery(LISTA_ESCOLAS_ANO_LETIVO, fnListaEscolasAnoLetivo); }

export default function* rootSaga() {
  yield all([
    fork(iniciaAcoesAnoLetivo),
    fork(salvaAnoLetivoW),
    fork(atualizaAnoLetivoW),
    fork(buscaAnoLetivoEdicaoW),
    fork(removeAnoLetivoW),
    fork(listaAnoLetivoW),
    fork(listaTiposEtapasAnoLetivoW)
    ,
    fork(listaEscolasAnoLetivoW),
    takeEvery(ANOLETIVO_TIPOETAPA_SALVAR, fnSalvarTipoEtapa),
    takeEvery(ANOLETIVO_TIPOETAPA_ATUALIZAR, fnAtualizarTipoEtapa)
  ]);
}
